import { ChangeEvent, useRef } from "react";

interface IProps {
  updateNFTs: (index: number) => void;
  updateSelectedContractAndFetchImages: (contract: string) => void;
  contract: string;
  walletTokenIdLookup: any;
}

let timeoutId: NodeJS.Timeout;

function IdSearch({
  updateNFTs,
  updateSelectedContractAndFetchImages,
  contract,
  walletTokenIdLookup,
}: IProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    walletTokenIdLookup.current = event.target.value;
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      updateNFTs(Number(event.target.value));
      // setTimeout(() => {
      //   if (inputRef.current) {
      //     inputRef.current.value = "";
      //   }
      // }, 500);
    }, 1000);
  };

  const clearSearch = () => {
    if (inputRef.current) {
      inputRef.current.value = "";
      walletTokenIdLookup.current = null;
      updateSelectedContractAndFetchImages(contract);
    }
  };

  return (
    <>
      <label htmlFor="id-search">
        ID:
        <input
          ref={inputRef}
          onChange={onChange}
          placeholder="TOKEN ID"
          type="text"
          className="id-search"
          id="id-search"
        ></input>
      </label>
      <span onClick={clearSearch}>{inputRef.current?.value ? "x" : ""}</span>
    </>
  );
}

export default IdSearch;
